import React, { useState, useEffect } from "react";
import { ArrowLeft, PlusCircle, Eye, Edit } from "react-feather";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { format } from "date-fns";
import { useTableSearch } from "core/Operations/useTableSearch";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { useVehicleIndemnityCategoriesQuery } from "AppQuries/master/VehicleIndeminty/vehicleindemnity";
import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";
import { useForm, useFormContext, FormProvider } from "react-hook-form";
import { numberToPointNumber } from "MainPages/Utils/decimal.utils";
import IndemnityModal from "Components/Modal/indemnity";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
import { yupResolver } from "@hookform/resolvers/yup";
import { VehicleIndemnityValidationSchema } from "core/Operations/ValidationSchema/MasterValidationSchema";
const VehicleIndemnity = () => {
  const userData = useSelector(loggedInUser);
  const { setValue, watch } = useFormContext();
  // const {
  //   data,
  //   isLoading,
  //   isError,
  //   error,
  //   refetch: GetItems,
  // } = useVehicleIndemnityCategoriesQuery({
  //   companyCode: userData?.companyCode,
  //   isTrue: true,
  // });
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [show, setShow] = useState(false);
  const methods = useForm({
    resolver: yupResolver(VehicleIndemnityValidationSchema)
  });
  // {
  //   // resolver: yupResolver(vehicleAccidentValidationSchema),
  // });

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const handleClose = () => {
    methods.reset();
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const handleAddClick = () => {
    setSelectedItem(null);
    methods.reset({
      indemnityID: 0,
      companyCode: 0,
      indemnityNumber: "",
      indemnityDate: "",
      driverName: "",
      driverNRICFin: "",
      ltA_HDB: "",
      noticeNumber: "",
      vendor: "",
      invoiceNumber: "",
      amount: 0,
      incidentAddress: "",
      issuedBy: "",
      designation: "",
      issuerNRIC: "",
      debitStaffAmount: 0,
      writeOffAmount: 0,
      description: "",
      vehicleNumber: "",
      createUser: userData.userName,
      createDate: getCurrentFormattedDate(),
      modifyUser: userData.userName,
      modifyDate: getCurrentFormattedDate(),
      isActive: true,
    });
    setShow(true);
  };

  const handleEditClick = (item) => {
    console.log(item);
    setSelectedItem(item);
    methods.reset({
      indemnityID: item.indemnityID,
      companyCode: item.companyCode ?? userData?.companyCode,
      indemnityNumber: item.indemnityNumber,
      indemnityDate: item.indemnityDate,
      driverName: item.driverName,
      driverNRICFin: item.driverNRICFin,
      ltA_HDB: item.ltA_HDB,
      noticeNumber: item.noticeNumber,
      vendor: item.vendor,
      invoiceNumber: item.invoiceNumber,
      amount: numberToPointNumber(item.amount),
      incidentAddress: item.incidentAddress,
      issuedBy: item.issuedBy,
      designation: item.designation,
      issuerNRIC: item.issuerNRIC,
      debitStaffAmount: item.debitStaffAmount,
      writeOffAmount: item.writeOffAmount,
      description: item.description,
      vehicleNumber: item.vehicleNumber,
      createUser: item.createUser,
      createDate: item.createDate,
      modifyUser: userData.userName,
      modifyDate: getCurrentFormattedDate(),
      isActive: true,
    });
    setShow(true);
  };

  // const deleteItemHandler = (id) => {
  //   const payload = {
  //     companyCode: userData?.companyCode,
  //     code: id,
  //   };
  //   deleteVehicleAccident(payload, {
  //     onSuccess: (data) => {
  //       if (data) {
  //         toast.success("Item Deleted Successfully.");

  //         setSelectedItem(null);
  //         setShow(false);
  //         // GetItems();
  //       } else {
  //         toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
  //       }
  //     },
  //     onError: (error) => {
  //       toast.error(error.message || "Something went wrong.");
  //     },
  //   });
  // };

  const onSubmit = async (payload) => {
    if (selectedItem) {
      console.log(payload);
      const existingDataIndex = watch("vehicleIndemnityList")?.findIndex(
        (item) => item.indemnityID === selectedItem.indemnityID
      );
      const existingData = watch("vehicleIndemnityList");

      existingData[existingDataIndex] = payload;

      setValue("vehicleIndemnityList", [...existingData]);
    } else {
      // const existingData = watch("vehicleIndemnityList");
      setValue("vehicleIndemnityList", [payload]);
    }
    setShow(false);
  };

  const columns = [
    // {
    //   title: "Indemnity ID",
    //   dataIndex: "indemnityID",
    //   sorter: (a, b) => a.indemnityID - b.indemnityID,
    // },
    // {
    //   title: "Company Code",
    //   dataIndex: "companyCode",
    //   sorter: (a, b) => a.companyCode - b.companyCode,
    // },
    {
      title: "Indemnity Number",
      dataIndex: "indemnityNumber",
    },
    {
      title: "Indemnity Date",
      dataIndex: "indemnityDate",
      render: (date) => format(new Date(date), "dd-MM-yyyy"),
    },
    {
      title: "Driver Name",
      dataIndex: "driverName",
    },
    {
      title: "Driver NRIC/FIN",
      dataIndex: "driverNRICFin",
    },
    {
      title: "LTA / HDB",
      dataIndex: "ltA_HDB",
    },
    {
      title: "Notice Number",
      dataIndex: "noticeNumber",
    },
    {
      title: "Vendor",
      dataIndex: "vendor",
    },
    {
      title: "Invoice Number",
      dataIndex: "invoiceNumber",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => a.amount - b.amount,
      render: (val) => `$${(val ?? 0).toFixed(2)}`,
    },
    {
      title: "Incident Address",
      dataIndex: "incidentAddress",
    },
    {
      title: "Issued By",
      dataIndex: "issuedBy",
    },
    {
      title: "Designation",
      dataIndex: "designation",
    },
    {
      title: "Issuer NRIC",
      dataIndex: "issuerNRIC",
    },
    {
      title: "Debit Staff Amount",
      dataIndex: "debitStaffAmount",
      sorter: (a, b) => a.debitStaffAmount - b.debitStaffAmount,
      render: (val) => `$${(val ?? 0).toFixed(2)}`,
    },
    {
      title: "Write-off Amount",
      dataIndex: "writeOffAmount",
      sorter: (a, b) => a.writeOffAmount - b.writeOffAmount,
      render: (val) => `$${(val ?? 0).toFixed(2)}`,
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      title: "Vehicle Number",
      dataIndex: "vehicleNumber",
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (text) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="add-new-tooltip">Edit</Tooltip>}
          >
            <button
              type="button"
              onClick={() => handleEditClick(record)}
              className="me-2 p-2"
              // to={`${all_routes.master}/${all_routes.editvehicleindemnity}`}
            >
              <Edit className="feather-edit" />
            </button>
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    watch("vehicleIndemnityList"),
    searchColumns
  );

  // if (isLoading) {
  //   return <LoadingSpinner />;
  // }

  // if (isError) {
  //   return <Error404 error={error} />;
  // }

  return (
    <>
      <h4 className="header-title">Indemnity</h4>

      <div className="card table-list-card border-0">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center">
            <TableTop
              onSearch={setSearchValue}
              toggleFilterVisibility={toggleFilterVisibility}
              isFilterVisible={isFilterVisible}
            />
            <button
              className="btn btn-primary"
              onClick={handleAddClick}
              type="button"
            >
              Add New
            </button>
          </div>

          <div className="table-responsive">
            <Table
              className="table  datanew"
              columns={columns}
              dataSource={filteredData}
            />
          </div>
        </div>
      </div>

      <FormProvider {...methods}>
        <IndemnityModal
          mode={selectedItem ? "E" : "I"}
          onSubmit={onSubmit}
          show={show}
          handleClose={handleClose}
        />
      </FormProvider>
    </>
  );
};

export default VehicleIndemnity;
